export const LivestockAnimalYoungId = '0175202d-7a00-433b-acc2-cdd35e57e709'
export const LivestockAnimalMatureId = 'bd5094d1-3e74-48bf-896a-ab25ac0d5240'
export const LivestockIsAnimalTermId = [LivestockAnimalYoungId, LivestockAnimalMatureId]

